export { default } from "./PrefetchOnIntentLink";
